import type { Element } from '../context/types';
import { Operation, type SectionReducerInput } from './types';

export const sectionElementReducer = ({ elements, operation, handlers }: SectionReducerInput): Element[] => {
  const { type, elementKey } = operation;
  const {
    selectElementByKey,
    deselectElementByKey,
    disableElementByKey,
    enableElementByKey,
    blockSection,
    enableSection,
  } = handlers;

  switch (type) {
    case Operation.SELECT:
      return selectElementByKey(elements, elementKey);
    case Operation.DESELECT:
      return deselectElementByKey(elements, elementKey);
    case Operation.BLOCK:
      return disableElementByKey(elements, elementKey);
    case Operation.ENABLE:
      return enableElementByKey(elements, elementKey);
    case Operation.BLOCK_SECTION:
      return blockSection(elements, elementKey);
    case Operation.ENABLE_SECTION:
      return enableSection(elements, elementKey);
    default:
      return elements;
  }
};
